import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);



class Thankyou extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      minOffset: 25,
      marginOffset: 0,
    };

    // Bind event listeners
    this.adjustHeight = ::this.adjustHeight;
  }

  componentWillMount() {
    window.addEventListener('resize', this.adjustHeight, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustHeight, false);
  }

  componentDidMount() {
    setTimeout(() => {
      this.adjustHeight();
    }, 50);
  }

  adjustHeight() {
    if(this.externalWrapper) {
      let offset = (window.innerHeight - (this.externalWrapper.offsetHeight - 40)) / 2; // 40 is an approximate adjust for difference between header and footer heights
      this.setState({ marginOffset: offset > this.state.minOffset ? offset : this.state.minOffset });
    }
  }

  pagesNav() {
    this.context.router.push('/');
  }

  openContact() {
    this.props.commonOpenNoItemContact();
  }

  render() {
    return <div className='Thankyou'>
      <div 
        className='thankyouWrapper'
        ref={(div) => { this.externalWrapper = div; }}
        style={{ marginTop: this.state.marginOffset + 'px' }}>
        <div className='thankyouInnerWrapper'>
          <div className='thankyouLogo'>
            <img src='/img/svg/DD_white.svg' alt='Diamonds Direct' />
          </div>
          {this.props.common.contactSent ?
            <div>
              <div className='thankyouTitle'>We look forward to meeting you!</div>
              <div className='thankyouSubTitle'>Have questions?</div>
            </div> :
            <div>
              <div className='thankyouTitle'>View the collection in person.</div>
            </div>
          }
          <div className='thankyouButtonWrapper'>
            <div className={'thankyouButton actionButton'} onClick={::this.openContact}>Contact Us</div>
          </div>
        </div>
      </div>
      <div className='leftNav' onClick={::this.pagesNav}>
        <img src='/img/svg/left.svg' />
      </div>
    </div>;
  }
}
export default Thankyou;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const ThankyouContainer = connect(
  mapStateToProps,
  allActionCreators
)(Thankyou);


// WEBPACK FOOTER //
// ./src/components/views/thankyou/Thankyou.jsx